import React, { useEffect, useState } from 'react';
import { resizeParent } from '@tccshared/services/Utils'
import Spinner from '../Spinner';
import { Modal } from '../Modal';
import { Portal } from '../Portal';

import { useConfiguration } from '../hooks/configure';
import { useRSS } from './rss.hooks';
import { RSSCard } from './RSSCard';
import { RSSTwentySeventeenCard } from './RSSTwentySeventeenCard';
export const TCCRSSReader = ({ site, feed, theme, limit = null }) => {

    const [page, setPage] = useState(1);
    const [loaded, setLoaded] = useState(false);
    const [className, setClassName] = useState('loading')

    let c = 'column-four';
    if (limit === "2") c = 'column-six';
    if (limit === "1") c = 'column-twelve';
    const [cardClassName, setCardClassName] = useState(c);


    // Configure
    const { loading: configLoading, result: configResult } = useConfiguration(site);

    // Get Events
    const { loading: rssLoading, result: rssResult } = useRSS({ feed, limit }, site);

    // Resize
    useEffect(() => { resizeParent(); }, [rssResult]);


    const renderCards = () => {

        let cardClassName = 'column-four';
        if (limit === "2" || rssResult.items.length === 2) cardClassName = 'column-six';
        if (limit === "1" || rssResult.items.length === 1) cardClassName = 'column-twelve';


        if (!rssResult.items) return;
        return rssResult.items.map((item, index) => {

            let openInModal = false;

            // Check For Youtube
            if (item.link.indexOf('youtube') > -1) { cardClassName += ' youtube'; openInModal = true; }
            if (item.link.indexOf('vimeo') > -1) { cardClassName += ' vimeo'; openInModal = true; }

            // Render Card
            if (theme == '2017') return (<RSSTwentySeventeenCard {...item} key={index} modal={openInModal} />);
            return (<RSSCard {...item} key={index} className={cardClassName} modal={openInModal} />)
        })

    }

    if (!rssResult) return (<div className="loading"><Spinner /></div>);

    return (
        <div className="TCCRSSReader">

            {renderCards()}

        </div>
    );

}